import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '../apis/client-axios';
import { STORAGE } from '../constants/Storage';
import { RootState } from './index';
import { axiosInstance } from '../apis';
import { ADMIN_ROUTE_NAME } from '../constants/RouteName';

export interface AuthState {
  loading: boolean;
  error: string;
  authUser?: User;
}

export const logout = () => {
  localStorage.removeItem(STORAGE.TOKEN);
  window.location.href = ADMIN_ROUTE_NAME.SIGNIN;
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: (): AuthState => {
    let initState: AuthState = {
      loading: false,
      error: '',
    };

    return initState;
  },
  reducers: {
    login: (state, action) => {
      localStorage.setItem(STORAGE.TOKEN, action.payload.data?.token);
      axiosInstance.defaults.headers.Authorization = action.payload.data?.token
        ? `Bearer ${action.payload.data?.token}`
        : '';
    },
    updateMe: (state, action: PayloadAction<User | undefined>) => {
      state.authUser = action.payload;
    },
  },
});

export const { updateMe, login } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
